<template>
    <tr class="document-allocations normal-wrap">
        <td class="left-border" :colspan="multiple_contractors ? 12 : 11">
            {{ __('settlement_date') }}: <strong>{{ correction.date }}</strong>&nbsp;|
            <span class="text-capitalize">{{ __('type') }}</span> <strong>{{ correction.type }}</strong>&nbsp;|
            {{ __('No') }}: <strong>{{ correction.number }}</strong>&nbsp;|
            {{ __('contractor') }}: <strong><truncated-text :text="correction.contractor" :max_length="100"/></strong>&nbsp;|
            {{ __('gross_amount') }}: <strong>{{ correction.gross_amount }}</strong>&nbsp;|
            {{ __('currency') }}: <strong>{{ correction.currency }}</strong>&nbsp;|
            {{ __('allocated') }}: <strong>{{ correction.allocated }}</strong>&nbsp;|
            {{ __('currency') }}: <strong> {{ correction.currency }}</strong>
        </td>
        <td class="text-right table-icons">
            <a v-show="controls.includes('destroy')"
                @click="destroy(correction)"
               :title="__('delete_connection')"
               class="icon-delete" data-toggle="tooltip" data-placement="top" >
                <i class="fa fa-trash"></i>
            </a>

            <a v-show="controls.includes('history')"
               :href="correction.history_url"
               :title="__('goto_contractor_history')"
               :data-original-title="__('goto_contractor_history')"
               data-toggle="tooltip" data-placement="top">
                <i class="fas fa-share"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import hasTooltips from './../../../mixins/hasTooltips.js'

    export default {
        name: "DocumentCorrections",
        mixins: [hasTooltips],
        methods: {
            destroy: function(correction) {
                this.$emit('destroy', correction);
            },
        },
        props: {
            correction: {
                type: Object,
                required: true
            },
            controls: {
                type: Array,
                required: false,
                default: () => ['destroy']
            },
            multiple_contractors: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
